export default function ({ children }) {

  if (import.meta.env.SSR) return null;
  return(
    <>
      {children}
    </>
  )
}
